import React from 'react'
import { useSelector } from 'react-redux'
import { Button, Typography, Divider, makeStyles } from '@material-ui/core'
import { Navigate, Route, Link as RouterLink } from 'react-router-dom'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Sidebar from './components/Sidebar'
import { sidebarWidth } from './components/Sidebar.styles'
import { SystemPrompts, ProjectPrompts, LLMSettings } from './routes'
import SentryRoutes from '../../components/SentryRoutes'

const useStyles = makeStyles(theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  main: {
    flex: 1,
    padding: theme.spacing(3),
    width: `calc(100% - ${sidebarWidth}px)`,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1.5),
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  backButton: {
    marginRight: theme.spacing(1.5),
    textTransform: 'none',
  },
}))

function AdminPage() {
  const classes = useStyles()
  const isLoggedIn = useSelector(state => state.auth.isUserLoggedIn)

  if (!isLoggedIn) return <Navigate to="/" replace />

  return (
    <div className={classes.mainContainer}>
      <Sidebar />
      <main className={classes.main}>
        <div className={classes.header}>
          <div className={classes.headerLeft}>
            <Button
              component={RouterLink}
              to="/"
              color="primary"
              size="small"
              className={classes.backButton}
              startIcon={<ArrowBackIcon />}
              aria-label="Go back to home"
            >
              Back
            </Button>
            <Typography variant="h5" component="h1">
              Admin Panel
            </Typography>
          </div>
        </div>
        <Divider />

        <SentryRoutes>
          <Route index element={<Navigate to="prompts/system" replace />} />
          <Route path="prompts/system" element={<SystemPrompts />} />
          <Route path="prompts/project" element={<ProjectPrompts />} />
          <Route path="llm-settings" element={<LLMSettings />} />
        </SentryRoutes>
      </main>
    </div>
  )
}

export default AdminPage
